import React from 'react';
import { Screen } from '../types';

const VerificationMethodScreen = ({ navigateTo }) => {
  return (
    <div className="ilp-screen gray-bg">
      <div className="ilp-header white-bg">
        <button className="ilp-back-btn" onClick={() => navigateTo(Screen.Consent)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h2>Verification Method</h2>
        <div className="ilp-header-spacer"></div>
      </div>

      <div className="ilp-verification-content">
        <div className="ilp-verification-intro">
          <h1>How would you like to verify?</h1>
          <p>Select a method to verify your identity using Aadhaar.</p>
        </div>

        <div className="ilp-verification-options">
          <button className="ilp-verification-option" onClick={() => navigateTo(Screen.AadhaarEKYC)}>
            <div className="ilp-option-icon blue">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <div className="ilp-option-text">
              <div className="ilp-option-title">
                <h4>Aadhaar OTP</h4>
                <span className="ilp-recommended-badge">Recommended</span>
              </div>
              <p>Fastest method. Requires mobile number linked to Aadhaar.</p>
            </div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="2">
              <path d="M9 5l7 7-7 7" />
            </svg>
          </button>

          <button className="ilp-verification-option" onClick={() => navigateTo(Screen.AadhaarDocument)}>
            <div className="ilp-option-icon orange">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                <path d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <div className="ilp-option-text">
              <h4>Scan Physical Card</h4>
              <p>Use your camera to scan Aadhaar or upload from gallery.</p>
            </div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="2">
              <path d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        <div className="ilp-info-box">
          <h5>Why Aadhaar?</h5>
          <p>Identity verification ensures the safety of all travelers and helps us provide a seamless entry experience at state checkpoints.</p>
        </div>
      </div>

      <div className="ilp-verification-footer">
        <div className="ilp-secure-note">
          <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
          </svg>
          <span>Secured Govt Infrastructure</span>
        </div>
      </div>
    </div>
  );
};

export default VerificationMethodScreen;

